import { __module as pseudo } from "../../../../../../../_virtual/pseudo.js";
import { __require as requireContainer } from "./container.js";
import { __require as requireTypes } from "./types.js";
var hasRequiredPseudo;
function requirePseudo() {
  if (hasRequiredPseudo) return pseudo.exports;
  hasRequiredPseudo = 1;
  (function(module, exports$1) {
    exports$1.__esModule = true;
    exports$1["default"] = void 0;
    var _container = _interopRequireDefault(requireContainer());
    var _types = requireTypes();
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : { "default": obj };
    }
    function _inheritsLoose(subClass, superClass) {
      subClass.prototype = Object.create(superClass.prototype);
      subClass.prototype.constructor = subClass;
      _setPrototypeOf(subClass, superClass);
    }
    function _setPrototypeOf(o, p) {
      _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o2, p2) {
        o2.__proto__ = p2;
        return o2;
      };
      return _setPrototypeOf(o, p);
    }
    var Pseudo = /* @__PURE__ */ (function(_Container) {
      _inheritsLoose(Pseudo2, _Container);
      function Pseudo2(opts) {
        var _this;
        _this = _Container.call(this, opts) || this;
        _this.type = _types.PSEUDO;
        return _this;
      }
      var _proto = Pseudo2.prototype;
      _proto.toString = function toString() {
        var params = this.length ? "(" + this.map(String).join(",") + ")" : "";
        return [this.rawSpaceBefore, this.stringifyProperty("value"), params, this.rawSpaceAfter].join("");
      };
      return Pseudo2;
    })(_container["default"]);
    exports$1["default"] = Pseudo;
    module.exports = exports$1.default;
  })(pseudo, pseudo.exports);
  return pseudo.exports;
}
export {
  requirePseudo as __require
};
//# sourceMappingURL=pseudo.js.map
